<div class="page-container">
  <div class="page-header">
    <p class="page-title">Users & Permissions</p>
  </div>
  <div class="content">
    <users-table
      [shopSupportsLocations]="shopSupportsLocations"
      [shopLocations]="shopLocations"
      (onUserClick)="handleUserOpen($event)"></users-table>
    <mat-drawer-container (backdropClick)="drawer.close()">
      <mat-drawer class="side-panel__position" autoFocus="false" #drawer mode="over" position="end">
        <user-details
          [shopSupportsLocations]="shopSupportsLocations"
          [shopLocations]="shopLocations"
          [drawer]="drawer"></user-details> </mat-drawer
    ></mat-drawer-container>
  </div>
</div>
